"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PhotoError = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var PhotoError = function PhotoError(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#PhotoError_svg__PhotoError_svg__clip0_18063_91078)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.345 2H2.498C.864 2 0 2.856 0 4.452v7.089C0 13.144.864 14 2.498 14h11.004C15.128 14 16 13.144 16 11.548V6.222A4 4 0 0110.345 2zM3.963 6.042c0 .892.77 1.654 1.67 1.654.916 0 1.678-.762 1.678-1.654 0-.914-.762-1.676-1.677-1.676-.901 0-1.67.762-1.67 1.676zm-2.256 5.375c0 .58.359.922.923.922h10.725c.58 0 .938-.341.938-.922v-1.306l-2.022-1.893c-.615-.566-1.084-.929-1.634-.929-.534 0-.996.37-1.626.929l-2.476 2.198-.843-.733c-.527-.457-.908-.769-1.355-.769-.447 0-.791.298-1.304.762l-1.326 1.197v.544z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.852 1.765a.506.506 0 10-.716-.717l-.836.836-.836-.836a.506.506 0 00-.716.717l.836.835-.836.836a.506.506 0 10.716.716l.836-.836.835.836a.506.506 0 00.717-.716l-.836-.836.836-.835z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "PhotoError_svg__PhotoError_svg__clip0_18063_91078"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  }))));
};

exports.PhotoError = PhotoError;
var _default = PhotoError;
exports.default = _default;